import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vModelText as _vModelText, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createVNode as _createVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["placeholder"]

import { onMounted, reactive, watch } from "vue";
  import { useAuctionStore } from "@/stores/AuctionStore";
  import { BaseIcon, CloseIcon } from "@/components/icons";
  import { trans } from "@/utils/trans";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'FilterSearch',
  setup(__props) {

  const auctionStore = useAuctionStore();

  const state = reactive({
    isShow: false,
    searchText: "" as string | null
  });

  watch(
    () => auctionStore.catalog.searchString,
    (nv) => {
      if (nv?.length) {
        state.isShow = true;
      }

      state.searchText = auctionStore.catalog.searchString;
    }
  );

  const clearSearch = () => {
    auctionStore.catalog.searchString = null;
    auctionStore.catalog.searchLots = null;
    state.isShow = false;
  };

  const clickToIcon = () => {
    if (!state.isShow) {
      state.isShow = true;
    } else {
      auctionStore.catalog.searchString = state.searchText;
    }
  };

  onMounted(() => {
    if (auctionStore.catalog.searchString?.length) {
      state.isShow = true;
      state.searchText = auctionStore.catalog.searchString;
    }
  });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({ show: state.isShow }),
    ref: "searchContainer"
  }, [
    _withDirectives(_createElementVNode("input", {
      type: "text",
      id: "search-lots",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((state.searchText) = $event)),
      placeholder: _unref(trans)('live.catalog.search.search_placeholder'),
      class: "input filter-search-input",
      onKeyup: _withKeys(clickToIcon, ["enter"])
    }, null, 40, _hoisted_1), [
      [_vModelText, state.searchText]
    ]),
    _createElementVNode("button", {
      onClick: _withModifiers(clickToIcon, ["prevent"]),
      class: "search-btn"
    }, _cache[1] || (_cache[1] = [
      _createElementVNode("svg", { class: "icon-search" }, [
        _createElementVNode("use", { href: "/sprite.svg#search" })
      ], -1)
    ])),
    (state.isShow)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "search-btn clear",
          onClick: clearSearch
        }, [
          _createVNode(_unref(BaseIcon), {
            class: "icon-close",
            "icon-name": "close",
            width: "12",
            height: "12",
            viewBox: "0 0 26.87 26.87"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(CloseIcon))
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})